import { ArrowRightLeftIcon } from 'lucide-react'
import { capitalize } from 'remeda'

import { WithdrawFromSavingsAction } from './types'
import { Token } from '@/domain/types/Token'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { ActionRow } from '@/features/actions/components/action-row/ActionRow'
import { ActionRowBaseProps } from '@/features/actions/components/action-row/types'

export interface WithdrawFromSavingsActionRowProps extends ActionRowBaseProps {
  action: WithdrawFromSavingsAction
}

export function WithdrawFromSavingsActionRow({
  action: { savingsToken, token, underlyingToken, amount, mode, displayMode },
  ...props
}: WithdrawFromSavingsActionRowProps) {
  const [titleTokens, titleParts]: [Token[], string[]] = (() => {
    if (displayMode === 'savings') {
      return [[savingsToken], [`Withdraw from ${savingsToken.symbol}`]]
    }

    if (underlyingToken.symbol === token.symbol) {
      return [[token], [`Withdraw ${token.symbol}`]]
    }

    if (underlyingToken.symbol === TokenSymbol('USDS') && token.symbol === TokenSymbol('USDT')) {
      return [
        [underlyingToken, token],
        ['Withdraw', `exchange to ${token.symbol}`],
      ]
    }

    return [
      [underlyingToken, token],
      ['Withdraw', `swap for ${token.symbol}`],
    ]
  })()

  return (
    <ActionRow {...props}>
      <ActionRow.Icon icon={ArrowRightLeftIcon} />

      <ActionRow.Title>
        <ActionRow.Title.Tokens tokens={titleTokens} />
        {concatSentenceParts([...titleParts, ...(mode === 'send' ? ['send'] : [])])}
      </ActionRow.Title>

      <ActionRow.Amount token={savingsToken} amount={amount} />

      <ActionRow.ErrorWarning />

      <ActionRow.Trigger>{mode === 'send' ? 'Send' : 'Withdraw'}</ActionRow.Trigger>
    </ActionRow>
  )
}

function concatSentenceParts(parts: string[]): string {
  function join(parts: string[]): string {
    if (parts.length === 0) return ''
    if (parts.length === 1) return `${parts[0]}`
    if (parts.length === 2) return `${parts[0]} and ${parts[1]}`

    const lastPart = parts[parts.length - 1]
    const otherParts = parts.slice(0, -1)
    return `${otherParts.join(', ')} and ${lastPart}`
  }

  return capitalize(join(parts))
}
